<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>{{ user.email }}</h1>
        </template>
        
        <div class="w-full">
            <div class="flex items-center py-1">
                <div class="flex-1">
                    <h3 class="font-bold">Manager Access</h3>
                    <p class="text-gray-darker text-sm">Managers have access to billing information and can delete the team</p>
                </div>
                <p-check class="p-switch p-fill" color="primary" v-model="isManager" @change="updateAccess" :disabled="!canChangeRole"></p-check>
            </div>
            <p class="text-destructive" v-if="errors.role && errors.role.length > 0">{{ errors.role[0] }}</p>
        </div>
        <div class="mt-4 w-full">
            <div class="flex items-center py-1">
                <div class="flex-1">
                    <h3 class="font-bold">Kick out</h3>
                    <p class="text-gray-darker text-sm">Remove this member from the team</p>
                </div>
                <a href class="text-sm font-bold text-destructive">
                    <span v-if="!kickoutConfirmed" @click.prevent="kickoutConfirmed = true">Remove</span>
                    <span v-else @click.prevent="kickout">Confirm?</span>
                </a>
            </div>
        </div>

        <div class="mt-4 w-full">
            <p class="text-destructive" v-if="errors.general && errors.general.length > 0">{{ errors.general[0] }}</p>
        </div>
    
        <template v-slot:footer>
            <button class="py-2 px-4 rounded-md bg-primary text-white font-bold" @click="close">Done</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    props: {
        team: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            canChangeRole   : window.User.id !== this.user.id,
            loading         : false,
            isManager       : this.user.role === 'manager',
            errors          : {},
            kickoutConfirmed: false,
        }
    },
    methods: {
        updateAccess() {
            this.errors = {};
            axios.put(`/api/teams/${this.team.id}/users/${this.user.id}`, {
                role: this.isManager ? 'manager' : 'member',
            }).catch(error => {
                this.errors = error.response.data.errors;
            });
        },
        kickout(){
            this.errors = {};
            axios.delete(`/api/teams/${this.team.id}/users/${this.user.id}`)
                .then(() => {
                    this.close();
                }).catch(error => {
                    this.errors = error.response.data.errors;
                });
        },
        close() {
            this.$emit('resolve');
        }
    }
}
</script>